import { render, staticRenderFns } from "./GiftCardMessageModal.vue?vue&type=template&id=109883d8&scoped=true&"
import script from "./GiftCardMessageModal.vue?vue&type=script&lang=js&"
export * from "./GiftCardMessageModal.vue?vue&type=script&lang=js&"
import style0 from "./GiftCardMessageModal.vue?vue&type=style&index=0&id=109883d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109883d8",
  null
  
)

export default component.exports